<template>
  <div class="numbercenter">
    <el-steps class="headStepTitle" :active="headStepItemCur" finish-status="success" simple v-if="headStepItemCur!=0">
      <el-step v-for="item in headStepList" :title="item.name" :key="item.id"></el-step>
    </el-steps>

    <div class="banner" v-if="headStepItemCur==0">
      <el-carousel indicator-position="none" arrow="never">
        <el-carousel-item v-for="(item,index) in bannerlist" :key="index">
          <img style="width:100%;height:250px;" :src="item.imgsrc" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="headStepCon">
      <step-one v-if="stepItemCur==0" @curNumberFunc="curNumberFunc"></step-one>
      <step-two v-if="stepItemCur==1" @gotoStepOneFunc="gotoStepOneFunc" @gotoStepThreeFunc="gotoStepThreeFunc" @needImgFunc="needImgFunc" :curNumber="curNumber" :curNumbercity="curNumbercity" :curNumberprovincecode="curNumberprovincecode" :curNumbercitycode="curNumbercitycode" :pretty="pretty"></step-two>
      <step-three v-if="stepItemCur==2" @gotoStepTwoFunc="gotoStepTwoFunc" @gotoStepFourFunc="gotoStepFourFunc" :orderid="orderid" :cardMoney="cardMoney" :needImg="needImg"></step-three>
      <step-four v-if="stepItemCur==3" @showStepFourFunc="showStepFourFunc" @gotoStepOneFunc="gotoStepOneFunc" :orderid="orderid" @gotoOrder="gotoOrder"></step-four>
    </div>
    <!-- <div class="footer">Copyright © 2019 远特（北京）通信技术有限公司</div> -->
  </div>
</template>

<script>
import stepOne from "@/pages/numbercenter/stepOne.vue";
import stepTwo from "@/pages/numbercenter/stepTwo.vue";
import stepThree from "@/pages/numbercenter/stepThree.vue";
import stepFour from "@/pages/numbercenter/stepFour.vue";
export default {
  name: "numbercenter",
  components: {
    stepOne,
    stepTwo,
    stepThree,
    stepFour
  },
  data(){
    return {
      headStepList : [
        {id:'0',name:'挑选号码'},
        {id:'1',name:'选择资费'},
        {id:'2',name:'提交订单'},
        {id:'3',name:'完成支付'},
      ],
      headStepItemCur : 0,
      stepItemCur : 0,
      bannerlist: [
        {
          name: 'sinaVip',
          imgsrc: require('../assets/banner1.png')
        }
      ],
      curNumber : '',
      curNumbercity : '',
      pretty : '',
      orderid : '',
      cardMoney : '',
      needImg : ''
    }
  },
  methods: {
    curNumberFunc : function(curNumber,curNumbercity,curNumberprovincecode,curNumbercitycode,pretty,showStepTwo) {
      this.curNumber = curNumber;
      this.curNumbercity = curNumbercity;
      this.curNumberprovincecode = curNumberprovincecode;
      this.curNumbercitycode = curNumbercitycode;
      this.headStepItemCur = showStepTwo;
      this.stepItemCur = showStepTwo;
      this.pretty = pretty;
    },
    gotoStepOneFunc : function(showStepOne){
      this.headStepItemCur = showStepOne;
      this.stepItemCur = showStepOne;
    },
    gotoStepThreeFunc : function(showStepThree,orderid,total_money){
      console.log(2222)
      this.headStepItemCur = showStepThree;
      this.stepItemCur =showStepThree;
      this.orderid = orderid;
      this.cardMoney = total_money;
    },
    gotoStepTwoFunc : function(showStepTwo){
      this.headStepItemCur = showStepTwo;
      this.stepItemCur =showStepTwo
    },
    gotoStepFourFunc : function(showStepFour){
      this.headStepItemCur = showStepFour;
      this.stepItemCur =showStepFour
    },
    showStepFourFunc : function(showStepFour){
      this.headStepItemCur = showStepFour;
    },
    gotoOrder : function(indexhead){
      this.$emit('changeindexhead',indexhead)
    },
    needImgFunc : function(needImg){
      console.log(needImg)
      this.needImg =needImg;
    }
  },
  created:function(){
    
  }
};
</script>

<style lang="less">
.numbercenter {
  .headStepTitle {
    background: #ffffff;
    width: 100%;
    height: 70px;
    padding: 0 180px 0 120px;
    box-sizing: border-box;
    margin-bottom: 30px;
  }
  .banner {
    width: 100%;
    height: 250px;
    overflow: hidden;
    margin-bottom: 30px;
    border-radius: 8px;
  }
  .headStepCon {
    margin-top: 20px;
    background: #ffffff;
    width: 100%;
    padding: 30px 70px;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .footer {
    color: #959698;
    font-size: 12px;
    padding-top: 20px;
  }
}
</style>
